
import { TransportMode, ApiColors } from "./../types";

interface ColorsDict {
  [key: string]: ApiColors;
}

export class Line {

  ref?: string;
  order?: number;
  name?: string;
  mnemo?: string;
  color?: string;
  colorText?: string;
  lineType?: number;
  categ?: string;
  mode?: TransportMode;
  colors?: ApiColors;
  refs?;

  constructor(ref: string, name: string, mnemo: string, color: string, colorText: string, lineType: number, order: number = 0, categ: string = "") {
    this.ref = ref
    this.name = name
    this.mnemo = mnemo
    this.lineType = lineType
    this.categ = categ
    this.order = order
    this.color = color
    this.colorText = colorText
    this.setColors()
    this.mode = this.getTranportMode()
  }

  setColors() {
    if (this.color && this.colorText) {
      let apiColors = {
        name: this.mnemo,
        bgcolor: "#" + this.color,
        color: "#" + this.colorText
      };
      //TODO recup settings lines colors (drupal config)
      this.colors = this.getLineColor([], this.mnemo, apiColors);
    } else {
      this.colors = this.getLineColor([], this.mnemo);
    }
  }

  getLineColor(
    linesColors: string[],
    line: string,
    apiColors?: ApiColors
  ): ApiColors {
    let colors: ColorsDict = {};
    for (let ligne of linesColors) {
      if (ligne !== "") {
        let parts = ligne.split("::");
        let name = parts[0];
        let bgcolor = parts[1];
        let color = parts[2];
        colors[name] = {
          name: name,
          bgcolor: bgcolor,
          color: color
        };
      }
    }
    if (colors[line]) {
      return colors[line];
    }
    if (apiColors) {
      colors[apiColors["name"]] = apiColors;
      return apiColors;
    }
    return {
      name: line,
      bgcolor: "#0074bd",
      color: "#000"
    };
  }


  getTranportMode(): TransportMode {
    switch (this.lineType) {
      case 0:
        return TransportMode.TRAM;
      case 1:
        return TransportMode.SUBWAY;
      case 2:
        return TransportMode.RAIL;
      case 3:
        return TransportMode.BUS;
      case 4:
        return TransportMode.FERRY;
      case 5:
        return TransportMode.CABLECAR;
      case 6:
        return TransportMode.GONDOLA;
      case 7:
        return TransportMode.FUNICULAR;
    }
    return TransportMode.BUS; //Default
  }
}
